import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleRemoveTask(
  list: Identifiable<List>,
  task: Boundaries["removeTask"]["success"],
): Identifiable<List> {
  return {
    ...list,
    tasks: list.tasks.filter(({ uuid }) => task.uuid !== uuid),
    subLists: list.subLists.map((subList) => handleRemoveTask(subList, task)),
  };
}

export { handleRemoveTask };
